//frontend/src/dropdownMap/1BAct7_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    9: "SubActivity",
    12: "Responsibility",
    14: "Gender",
    16: "PovertyLevel",
    17: "PWDStatus",
    18: "StarterKitReceived",
    19: "Certified",
    20: "EngagedInCommercial",
};

export const dropdownOptions = {
    //internal values should match database stored values
    //LA and EN values are for display purpose

    SubActivity: {
        internal: [
            "subact7_001", "subact7_002", "subact7_003", "subact7_004", "subact7_005",
            "subact7_006", "subact7_007", "subact7_008", "subact7_009", "subact7_010",
            "subact7_011", "subact7_012", "subact7_013", "subact7_014", "subact7_015",
            "subact7_016", "subact7_017", "subact7_018", "subact7_019", "subact7_020"
        ],
        LA: {
            "subact7_001": "ສາທິດການປູກເຫັດ",
            "subact7_002": "ສາທິດການປູກຖົ່ວຍາວ",
            "subact7_003": "ສາທິດການປູກຜະລິດຫຍ້າອາຫານສັດ",
            "subact7_004": "ສາທິດປູກພືດຜັກຕາມລະດູການ",
            "subact7_005": "ສາທິດການປູກເຂົ້າ",
            "subact7_006": "ສາທິດການປູກພືດຜັກ ໃນເຮືອນຮົ່ມ",
            "subact7_007": "ສາທິດການປູກຜັກທຽມ",
            "subact7_008": "ສາທິດການປູກຫອມປ້ອມນອກລະດູ",
            "subact7_009": "ສາທິດການຜະລິດລູກແບ້",
            "subact7_010": "ສາທິດການຜະລິດລູກໝູ",
            "subact7_011": "ສາທິດການລ້ຽງປາດຸກໃນໜອງຜ້າຢາງ",
            "subact7_012": "ສາທິດການລ້ຽງກົບ+ສວນຄົວ",
            "subact7_013": "ສາທິດການລ້ຽງປາ + ລ້ຽງໝູ",
            "subact7_014": "ສາທິດການຜະລິດລູກປານິນ",
            "subact7_015": "ສາທິດການທອມງົວ",
            "subact7_016": "ສາທິດການລ້ຽງໝູລາດ",
            "subact7_017": "ສາທິດການລ້ຽງໄກ່ລາດ",
            "subact7_018": "ການລົງຮຽນຮູ້ ກັບຈຸດສາທິດ",
            "subact7_019": "ຄັດເລືອກວິຊາການບ້ານ",
            "subact7_020": "ລົງໃຫ້ບໍລິການກັບທີ່"
        },
        EN: {
            "subact7_001": "Mushroom production",
            "subact7_002": "Long bean cultivation technique",
            "subact7_003": "Forage Production and processing (Silage)",
            "subact7_004": "Seasonal Vegetable production",
            "subact7_005": "Rice growing",
            "subact7_006": "Veg growing in sheding house (greenhouse)",
            "subact7_007": "Garlic production",
            "subact7_008": "Coriander production-off season",
            "subact7_009": "Goat breeding/raising",
            "subact7_010": "Local pig breeding/ raising",
            "subact7_011": "Catfish raising in plastic artificial pond/ integrated with HG",
            "subact7_012": "Frog raising integrated with home garden",
            "subact7_013": "Fish farming integrated with pig raising",
            "subact7_014": "Tilapia fingerling production in cage",
            "subact7_015": "Cattle fattening",
            "subact7_016": "Local pig raising",
            "subact7_017": "Local chicken raising",
            "subact7_018": "On-the- job Training (OJT) in Demo plots",
            "subact7_019": "Selection of LF",
            "subact7_020": "On-site serivices"
        }
    },
    Responsibility: {
        internal: ["lf", "lf_l", "vvw","vf","villager","apg_member"],
        LA: { "lf": "ກະສິກອນຕົວແບບດ້ານປູກຝັງ", "lf_l": "ກະສິກອນຕົວແບບດ້ານລ້ຽງສັດ", "vvw": "ສັດຕະວະແພດບ້ານ" , "vf": "ຜູ້ອຳນວຍຄວາມສະດວກໂພຊະນາການຂັ້ນບ້ານ", "villager": "ຊາວບ້ານ", "apg_member": "ສະມາຊິກກຸ່ມ" },
        EN: { "lf": "LF-C", "lf_l": "LF-L" , "vvw": "VVW", "vf": "VF", "villager": "Villager", "apg_member": "APG Member" }
    },
    Gender: {
        internal: ["Male", "Female"],
        LA: { "Male": "ຊາຍ", "Female": "ຍິງ" },
        EN: { "Male": "Male", "Female": "Female" }
    },
    PovertyLevel: {
        internal: ["p", "np"],
        LA: { "p": "P", "np": "NP" },
        EN: { "p": "P", "np": "NP" }
    },
    PWDStatus: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },
    StarterKitReceived: {
        internal: ["0", "1"],
        LA: { "0": "No", "1": "Yes" },
        EN: { "0": "No", "1": "Yes" }
    },
    Certified: {
        internal: ["c_no", "c_yes"],
        LA: { "c_no": "No", "c_yes": "Yes" },
        EN: { "c_no": "No", "c_yes": "Yes" }
    },
    EngagedInCommercial: {
        internal: ["engage_no", "engage_yes"],
        LA: { "engage_no": "No", "engage_yes": "Yes" },
        EN: { "engage_no": "No", "engage_yes": "Yes" }
    }
};

// Reverse mapping: LA → _male etc.
// export const dropdownReverseMap = {};
// Object.keys(dropdownOptions).forEach(field => {
//     dropdownReverseMap[field] = { LA: {}, EN: {} };
//     const opts = dropdownOptions[field];
//     opts.internal.forEach(intVal => {
//         dropdownReverseMap[field].LA[opts.LA[intVal]] = intVal;
//         dropdownReverseMap[field].EN[opts.EN[intVal]] = intVal;
//     });
// });
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal); // force string
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});
